import React, { useState } from "react";
import { Button, Tabs, message } from "antd";
import { NextButton, PreviousButton } from "@comps/components";
import IndexAttendancePolicyPlanner from "@mods/policyManagement/attendancePolicyPlanner/IndexAttendancePolicyPlanner";
import IndexPayrolls from "@mods/payrollManagement/payrolls/IndexPayrolls";
import IndexPayrollConfigurations from "@mods/payrollManagement/settings/configurations/IndexPayrollConfigurations";
import ReadinessSummary from "./ReadinessSummary";

// Step 8 — Payroll & Policies. Brings payroll setup into one place by reusing the
// real screens:
//   • Payroll Policies -> IndexAttendancePolicyPlanner (embedded planner)
//   • Manage Payroll   -> IndexPayrolls (create/run/close/workspace)
//   • Payroll Settings -> IndexPayrollConfigurations
// Optional/skippable step: Continue is always enabled.

const StepPayrollPolicies = (props) => {
  const { onNext, onBack, readiness, readinessLoading, refreshReadiness, statuses, skipStep, clearSkip } = props;
  const [activeTab, setActiveTab] = useState("policies");

  const continueStep = () => {
    clearSkip?.("payrollpolicies");
    refreshReadiness?.();
    onNext();
  };

  const skip = () => {
    skipStep?.("payrollpolicies");
    message.info("Payroll setup skipped for now.");
    onNext();
  };

  const items = [
    {
      key: "policies",
      label: "Payroll Policies",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Set up the policies that affect payroll (deductions, encashment, attendance planners). These feed
            straight into how salaries are calculated.
          </div>
          <IndexAttendancePolicyPlanner modkey="requestPolicies" embedded />
        </div>
      ),
    },
    {
      key: "manage",
      label: "Manage Payroll",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Create a payroll, add employees, then run, review and close it — all from here.
          </div>
          <IndexPayrolls modkey="payrolls" />
        </div>
      ),
    },
    {
      key: "settings",
      label: "Payroll Settings",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Configure payroll behaviour (final settlement, negative-salary handling, settlement notes), then Save.
          </div>
          <IndexPayrollConfigurations modkey="payrollConfigurations" />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="onb-card-title">Payroll &amp; policies</div>
      <div className="onb-card-sub">
        Optional: review payroll policies, payroll runs and payroll settings now, or finish setup and come back later.
      </div>

      <ReadinessSummary
        status={statuses.payrollpolicies}
        loading={readinessLoading}
        onRefresh={refreshReadiness}
        items={[
          { label: "Payroll settings", value: readiness.payroll.configured ? "Saved" : "Not saved" },
          { label: "Payrolls", value: readiness.payroll.payrollCount || 0 },
        ]}
      />

      <Tabs
        className="onb-tabs"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />

      <div className="onb-foot">
        <PreviousButton onClick={onBack} text="Back" />
        <span className="spacer" />
        <Button onClick={skip}>Skip for now</Button>
        <NextButton onClick={continueStep} text="Continue" />
      </div>
    </>
  );
};

export default StepPayrollPolicies;
